<template>
  <div class="row justify-content-end">
    <div class="col-6 col-md-4 text-right">
      <button class="btn btn-sm btn-danger" @click.prevent="logout"><i class="fas fa-sign-out-alt"></i> ออกจากระบบ</button>
    </div>

  </div>
</template>¸

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapState({
      professional: state => state.auth.professional,
      tokenProfessional: state => state.auth.tokenProfessional
    })
  },
  methods: {
    async logout () {
      /* try {
        const headers = { 'Authorization': `Bearer ${this.tokenProfessional}` }
        await axios.post('/professional/logout', {
          professional_id: this.professional.id
        }, {
          headers
        })
      } catch (err) {
        console.log('ผิดพลาด ' + err.message)
      } */

      this.$swal({
        title: 'คุณแน่ใจหรือไม่ ?',
        text: 'ยืนยันในการออกจากระบบ',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#9E9E9E',
        reverseButtons: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then(() => {
        this.$store.dispatch('auth/LOGOUT_PROFESSIONAL')
        this.$router.replace({ name: 'Professional Login' })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/professional/components/Header.vue